import { Link } from "react-router-dom";

export function SubscribeConfirmPage() {
  return (
    <main className="aptean-page aptean-subscribe-confirm">
      <div className="aptean-subscribe-confirm__card">
        <h1 className="aptean-subscribe-confirm__heading">
          You're subscribed!
        </h1>
        <p className="aptean-subscribe-confirm__message">
          You'll receive alerts for the selected services whenever their status changes.
        </p>
        <Link to="/status" className="aptean-btn aptean-btn--secondary">
          Back to status
        </Link>
      </div>
    </main>
  );
}
